import React from 'react';
import { Hero } from '../components/Hero';
import { WhyPay } from '../components/WhyPay';
import { BenefitCards } from '../components/BenefitCards';
import { HowItWorks } from '../components/HowItWorks';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { ContactSection } from '../components/ContactSection';
import { TravelBand } from '../components/TravelBand';
export function Home() {
  return <>
      <Hero data-id="element-582" data-mp="1zjs8s0q82z7o" />
      {/* Answer "why pay if it's free?" right away — establishes the value
          before the visitor sees the price. */}
      <WhyPay data-id="element-583" data-mp="29gdekoa2geck" />
      <Pricing data-id="element-584" data-mp="29fvgrn7r9s2j" />
      <BenefitCards data-id="element-585" data-mp="29fc1ke9hphs7" />
      <HowItWorks data-id="element-586" data-mp="29etv6ot45n6k" />
      <FAQ data-id="element-587" data-mp="29ihmriezzzin" />
      <ContactSection data-id="element-588" data-mp="2dhgs344n5yam" />
      {/* Franja de afiliados de viaje (Travelpayouts), antes del pie legal. */}
      <TravelBand data-id="element-589" data-mp="3kvk3cdh3kp2t" />
    </>;
}